module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list', {
    staticClass: "md-double-line",
    attrs: {
      "id": "ql-sidenav-layer-list"
    }
  }, [_c('md-dialog-confirm', {
    ref: "deleteLayerDialog",
    attrs: {
      "md-title": 'Confirm Layer Delete',
      "md-content-html": 'This layer contains cues. Are you sure you want to delete it?',
      "md-ok-text": 'Yes',
      "md-cancel-text": 'Cancel'
    },
    on: {
      "close": _vm.dialogClose
    }
  }), _vm._v(" "), _vm._l((_vm.getAllLayers), function(layer) {
    return _c('layer', {
      key: layer.id,
      attrs: {
        "layer": layer,
        "viewable": _vm.canView(layer),
        "viewableLayer": _vm.canViewLayer(layer),
        "editable": _vm.canEdit(layer),
        "layerTitleFontSize": _vm.getTitleFontSize(layer),
        "layerDefaultCuePlacement": _vm.getDefaultCuePlacementPrint(layer.id),
        "layerLineOpacity": _vm.getCueLineOpacity({
          layer: layer.id
        }),
        "layerCueBoxOpacity": _vm.getLayerBoxOpacity({
          layer: layer.id
        }),
        "layerAutoNumbering": _vm.getLayerAutoNumbering(layer.id),
        "layerAutoNumberStart": _vm.getLayerAutoNumberStart(layer.id),
        "layerAutoNumberInterval": _vm.getLayerAutoNumberInterval(layer.id),
        "showNotes": _vm.canShowNotes(layer),
        "showCues": _vm.canShowCues(layer),
        "headerBox": _vm.getHeaderBox(layer),
        "userDefined": _vm.getUserDefined(layer)
      },
      on: {
        "deleteLayer": _vm.tryDeleteLayer,
        "close": _vm.emitClose
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-465bfd0c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layers/layer-list.vue
// module id = 1236
// module chunks = 21